import { activeCampaignVariant } from '@/lib/activeCampaign';

/**
 * The `sourceUrl` every form submission sends, with the campaign variant of
 * the page on screen attached as `?campaign=` — the rendered Page's variant,
 * not the visitor's cookie (SH-471), so a lead from a page without a campaign
 * template reports `a`.
 *
 * The page's own URL is not enough: `CampaignCookieSync` strips `?campaign=`
 * out of it in an effect right after landing, so by the time anyone submits a
 * form the param is gone from `window.location`, and the CRM needs the variant
 * on the lead.
 *
 * `set`, not `append`: until that effect has run the param is still in the
 * URL, and appending would send two of them.
 */
export function sourceUrlWithCampaign(): string {
  const url = new URL(window.location.href);
  url.searchParams.set('campaign', activeCampaignVariant());
  return url.toString();
}
